import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { fetchQualificationIfNeeded, fetchQualification } from '../../actions/qualification';
import { mapQualification } from '../../reducers/qualificationReducer';
import EditPanel from './EditPanel';

const Qualification = ({
  loaded,
  dispatch,
  showErrorMessage,
  errorMessage,
  qualificationData,
  EmployeeMasterID,
}) =>
  (<EditPanel
    title={<FormattedMessage id="qualification.title" />}
    emptyText="qualification.empty"
    loaded={loaded}
    showErrorMessage={showErrorMessage}
    errorMessage={errorMessage}
    onOpen={() => dispatch(fetchQualificationIfNeeded())}
    modelName="EmployeeMasterQualification"
    dataSource={qualificationData}
    mapModel={mapQualification}
    EmployeeMasterID={EmployeeMasterID}
    fetchData={fetchQualification}
  />);

function mapStateToProps(state) {
  return {
    loaded: state.qualificationReducer.loaded,
    form: state.form.EmployeeMasterQualification,
    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
    qualificationData: state.qualificationReducer.qualificationData,
    showErrorMessage: (state.qualificationReducer.error && state.qualificationReducer.error.Message.length) > 0,
    errorMessage: (state.educationReducer.error && state.educationReducer.error.Message) || '',
  };
}

Qualification.propTypes = {
  loaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  qualificationData: PropTypes.array,
  showErrorMessage: PropTypes.bool,
  errorMessage: PropTypes.string,
  EmployeeMasterID: PropTypes.number,
};

export default connect(mapStateToProps)(Qualification);



// WEBPACK FOOTER //
// ./src/components/profile/Qualification.js